import React from "react";
import { connect } from "react-redux";

import {
  Pagination as BootstrapPagination,
  PaginationLink,
  PaginationItem,
} from "reactstrap";

class Pagination extends React.Component {
  constructor() {
    super();
  }

  setPage(page) {
    const { setPage, afterPageChange } = this.props;

    setPage(page);
    if (afterPageChange) {
      afterPageChange();
    }
  }

  getHref(page) {
    const { url, numberOfPages } = this.props;
    if (page === 0) {
      return url;
    }
    if (page === numberOfPages + 1) {
      return url;
    }

    return page == 1 ? (url == "" ? "/" : url) : `${url}/p/${page}`;
  }

  render() {
    const { numberOfPages, url, currentPage } = this.props;
    let { maxPagesDisplay } = this.props;

    const setPage = this.setPage;

    let withDots = true;
    if (maxPagesDisplay >= numberOfPages) {
      withDots = false;
    }
    if (maxPagesDisplay > numberOfPages) {
      maxPagesDisplay = numberOfPages;
    }

    let items = [];

    let i =
      currentPage - parseInt(maxPagesDisplay / 2) < 1
        ? 1
        : currentPage + parseInt(maxPagesDisplay / 2) > numberOfPages
        ? numberOfPages - maxPagesDisplay + 1
        : currentPage - parseInt(maxPagesDisplay / 2);

    const limit = i + maxPagesDisplay;

    for (i; i < limit; i++) {
      items.push(
        <PaginationItem
          key={i}
          active={i === currentPage}
          onClick={setPage.bind(this, i)}
        >
          <PaginationLink
            href={this.getHref(i)}
            onClick={(e) => e.preventDefault()}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }

    const first = withDots ? (
      maxPagesDisplay > numberOfPages ? null : currentPage -
          parseInt(maxPagesDisplay / 2) >
        1 ? (
        <PaginationItem
          active={1 === currentPage}
          onClick={setPage.bind(this, 1)}
        >
          <PaginationLink
            href={this.getHref(1)}
            onClick={(e) => e.preventDefault()}
          >
            {1}
          </PaginationLink>
        </PaginationItem>
      ) : null
    ) : null;
    const last = withDots ? (
      maxPagesDisplay > numberOfPages ? null : currentPage <
        numberOfPages - parseInt(maxPagesDisplay / 2) ? (
        <PaginationItem
          active={numberOfPages === currentPage}
          onClick={setPage.bind(this, numberOfPages)}
        >
          <PaginationLink
            href={this.getHref(numberOfPages)}
            onClick={(e) => e.preventDefault()}
          >
            {numberOfPages}
          </PaginationLink>
        </PaginationItem>
      ) : null
    ) : null;

    if (first !== null) {
      items.shift();
    }

    if (last !== null) {
      items.pop();
    }

    const prev = (
      <PaginationItem
        disabled={currentPage === 1}
        onClick={currentPage !== 1 ? setPage.bind(this, currentPage - 1) : null}
      >
        <PaginationLink
          href={this.getHref(currentPage - 1)}
          onClick={(e) => e.preventDefault()}
        >
          <i className="fa fa-2x fa-arrow-circle-o-left" />
          <span className="hidden-xs-down">POPRZEDNIE</span>
        </PaginationLink>
      </PaginationItem>
    );

    const next = (
      <PaginationItem
        disabled={currentPage === numberOfPages}
        onClick={
          currentPage !== numberOfPages
            ? setPage.bind(this, currentPage + 1)
            : null
        }
      >
        <PaginationLink
          href={this.getHref(currentPage + 1)}
          onClick={(e) => e.preventDefault()}
        >
          <span className="hidden-xs-down">NASTĘPNE</span>
          <i className="fa fa-2x fa-arrow-circle-o-right" />
        </PaginationLink>
      </PaginationItem>
    );

    if (numberOfPages > 1) {
      return (
        <BootstrapPagination>
          {prev}
          {first}
          {first !== null ? (
            <PaginationItem disabled>
              <PaginationLink>...</PaginationLink>
            </PaginationItem>
          ) : null}
          {items}
          {last !== null ? (
            <PaginationItem disabled>
              <PaginationLink>...</PaginationLink>
            </PaginationItem>
          ) : null}
          {last}
          {next}
        </BootstrapPagination>
      );
    } else {
      return <div />;
    }
  }
}

export default connect((state) => ({}), {})(Pagination);



/** WEBPACK FOOTER **
 ** ./src/browser/components/Pagination/Pagination.js
 **/